type AnalysingLoadingGifProps = {
  width?: number;
  height?: number;
};

export const AnalysingLoadingGif: React.FC<AnalysingLoadingGifProps> = ({
  width = 60,
  height = 60
}) => {
  return (
    <img
      src="/Analysing-400x400.gif"
      alt="Analysing"
      style={{ width, height, objectFit: 'contain' }}
      onError={(e) => {
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};
